module.exports = __webpack_public_path__ + "static/GothamRounded-Book-f209c3e4ce1f5617586a0c326b99d436.ttf";